/**
 * 【KYMW1407】画像リスト取得VO
 *
 * @export GetImageListModel
 * @class GetImageListModel
 */
export class GetImageListModel {
  // コマID
  public komaID = String('');
}
